// ---Dependencies
import React from 'react';
// ---UI Dependencies
import {Brand} from '@dtci/spellbook/NavBar';
import LottiePlayer from '@dtci/spellbook/LottiePlayer';
import dneLogo from '../../../shared/assets/img/logo.png';
import myIDLogo from '../../../shared/assets/img/myid.png';
import styles from './login.module.scss';
// ---Redux
import {useSelector} from 'react-redux';
// ---Configs
import {ENDPOINTS_KEYS} from '../../config/constants';
import {Header} from "../../components/Header";
import {tracker} from '../../analytics/snowplow';
import { getCurrentUser } from '../../utils/localStorageService';
/**
 * Login Component
 *
 * This component serves as the login page for the application.
 * It includes a brand logo, a title, and a login button.
 * It also handles error states and loading indicators.
 *
 * @component
 * @returns {JSX.Element} The login page with branding and login functionality.
 **/
export const Login = () => {
    React.useEffect(() => {
        var currentUser = getCurrentUser();        
        tracker.setUserId(currentUser);
        tracker.trackPageView({ title: 'Login' });
    }, []);

    const error = useSelector((s) => s.auth.error);
    const {showSpinner} = useSelector((s) => s.spinner);
    const hasError = error !== '';

    return (
        <>
            <Header/>
            <div className={styles.root}>
                <div className={styles.leftPanel}>
                    <div className={styles.bgImg}/>
                </div>
                <div className={styles.rightPanel}>
                    <div className={styles.content}>
                        <h1 className={styles.title} data-error={hasError}>
                            {hasError ? '403 Unauthorized' : 'Login to Clearances UI'}
                        </h1>
                        <div className={styles.divider} data-error={hasError}>
                            <hr/>
                            <span>{hasError ? 'You are not authorized' : 'Continue with'}</span>
                            <hr/>
                        </div>
                        {showSpinner ? (
                            <LottiePlayer
                                style={{
                                    position: 'relative',
                                    maxWidth: '120px',
                                    marginInline: 'auto',
                                }}
                            />
                        ) : (
                            <>
                                {hasError && <p className={styles.error}>{error}</p>}
                                {!hasError && (
                                    <a href={ENDPOINTS_KEYS.login} className={styles.myID}>
                                        Login with
                                        <img src={myIDLogo} alt="Disney MyID"/>
                                    </a>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
